
'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

define('component!AddAppModalComponent',['require','react','create-react-class','translate','component!ModalComponent','lib/Podio.Config','lib/Podio.Routes'],function (require) {
  'use strict';

  var React = require('react');
  var ReactCreateClass = require('create-react-class');
  var t = require('translate');

  var ModalComponent = require('component!ModalComponent');

  var config = require('lib/Podio.Config');
  var routes = require('lib/Podio.Routes');

  var AddAppModalComponent = ReactCreateClass({
    displayName: 'AddAppModalComponent',

    UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
      this.modal = React.createRef();
      var route = routes.new_app_path(config.orgSlug, config.space_url_label, { format: 'html' });

      this.setState({
        newAppUrl: route
      });
    },

    render: function render() {
      return React.createElement(
        ModalComponent,
        _extends({}, this.props, { ref: this.modal, className: 'add-app-modal-component' }),
        React.createElement(
          'header',
          { className: 'l-modal-header' },
          React.createElement(
            'h1',
            { className: 'header-title' },
            t('Add app #add.app.modal')
          )
        ),
        React.createElement(
          'div',
          { className: 'modal-content' },
          React.createElement(
            'a',
            { id: 'new-app-link', href: this.state.newAppUrl, className: 'box', onClick: this.handleOnCreateAppClick.bind(null, 'custom') },
            React.createElement('img', { src: '/images/components/AddAppModalComponent/tools_icon_large.png' }),
            React.createElement(
              'p',
              null,
              t('Create your own app #add.app.modal')
            ),
            React.createElement(
              'span',
              null,
              t('Use the app creator to build it yourself in minutes. #add.app.modal')
            )
          ),
          React.createElement(
            'div',
            { className: 'split' },
            React.createElement(
              'span',
              null,
              t('or #add.app.modal')
            )
          ),
          React.createElement(
            'a',
            { href: '/market', className: 'box', onClick: this.handleOnCreateAppClick.bind(null, 'market') },
            React.createElement('img', { src: '/images/components/AddAppModalComponent/store_icon_large.png' }),
            React.createElement(
              'p',
              null,
              t('Go to the App Market #add.app.modal')
            ),
            React.createElement(
              'span',
              null,
              t('Pick one of the predefined apps made by people who work just like you. #add.app.modal')
            )
          )
        )
      );
    },

    handleOnCreateAppClick: function handleOnCreateAppClick(type, syntheticEvent) {

      this.modal.current.close();
    }
  });

  return AddAppModalComponent;
});
